/** Brief 12, K3 - Moliya. */
export const uzB12Moliya = {
  "moliya.title": "Moliya",
  "moliya.rate": "CBU · 1 $ = {rate} so'm",
  "moliya.pay": "To'lov kiritish",
  "moliya.denied": "{role} roli bu bo'limni ko'rmaydi. Kerak bo'lsa, agentlik egasiga yozing.",
  "moliya.home": "Bosh sahifaga",
  "moliya.loadError": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "moliya.loadErrorTitle": "Ma'lumotni olib bo'lmadi",
  "moliya.empty.title": "To'lov hali yo'q",
  "moliya.empty.message": "Birinchi to'lovni kiriting yoki Payme · Click havolasini mijozga yuboring.",
  "moliya.setupKassas": "Kassalarni sozlash",
  "moliya.kpi.label": "Moliya ko'rsatkichlari",
  "moliya.kpi.income": "Bugun tushum",
  "moliya.kpi.incomeSub": "{count} ta to'lov",
  "moliya.kpi.debts": "Mijozlar qarzi",
  "moliya.kpi.debtsSub": "{deals} bitim · {late} kechikkan",
  "moliya.kpi.providers": "Turoperatorlarga",
  "moliya.kpi.providersSub": "7 kun ichida",
  "moliya.kpi.pending": "Tasdiq kutmoqda",
  "moliya.kpi.pendingSub": "to'lov",
  "moliya.tabs.label": "Moliya bo'limlari",
  "moliya.tab.in": "To'lovlar",
  "moliya.tab.debt": "Mijozlar qarzi",
  "moliya.tab.ops": "Turoperatorlarga",
  "moliya.tab.kas": "Kassalar",
  "moliya.more": "Yana",
  "moliya.tab.expenses": "Chiqimlar",
  "moliya.tab.approvals": "Tasdiq navbati",
  "moliya.tab.vendors": "Ta'minotchilar",
  "moliya.tab.links": "To'lov havolalari",
  "moliya.addExpense": "Chiqim kiritish",
  "moliya.due.title": "Operatorga to'lov muddatlari",
  "moliya.due.source": "manba: Bronlar · operator xabarlari",
  "moliya.due.rest": "{provider} · {amount} qoldiq",
  "moliya.due.full": "{provider} · {amount}",
  "moliya.due.fly": "uchish {date}",
  "moliya.due.risk": "bekor bo'lish xavfi",
  "moliya.due.done": "Bajarildi",
  "moliya.due.toast": "To'lov vazifasi bajarildi · {name}",
  "moliya.due.today": "bugun gacha",
  "moliya.due.tomorrow": "ertaga gacha",
  "moliya.due.until": "{date} gacha",
  "moliya.due.late": "Kechikkan · {days} kun",
  "moliya.link.booking": "Bron",
  "moliya.link.deal": "Bitim",
  "moliya.col.time": "Vaqt",
  "moliya.col.clientDeal": "Mijoz · bitim",
  "moliya.col.kassa": "Kassa",
  "moliya.col.amount": "Summa",
  "moliya.col.inSom": "So'mda",
  "moliya.col.status": "Holat",
  "moliya.col.fly": "Uchish",
  "moliya.col.total": "Jami",
  "moliya.col.rest": "Qoldiq",
  "moliya.col.due": "Muddat",
  "moliya.col.provider": "Turoperator",
  "moliya.col.payable": "To'lanadi",
  "moliya.col.fromClient": "Mijozdan",
  "moliya.bookingRef": "bron {ref}",
  "moliya.flyLine": "uchish {date}",
  "moliya.fromClientLine": "mijozdan {amount}",
  "moliya.approve": "Tasdiqlash",
  "moliya.approved": "To'lov tasdiqlandi · {name}",
  "moliya.reject": "Bekor qilish",
  "moliya.storno": "Storno",
  "moliya.rowMenu": "To'lov amallari",
  "moliya.manualRate": "qo'lda kiritilgan kurs",
  "moliya.sendLink": "Havola yuborish",
  "moliya.sent": "To'lov havolasi {name}ga {channel} orqali yuborildi",
  "moliya.sentCopied": "{name} bilan suhbat yo'q. Havola nusxalandi, qo'lda yuboring",
  "moliya.sentNoCopy": "{name} bilan suhbat yo'q. Havola yaratildi, bitim kartasidan yuboring",
  "moliya.enter": "Kiritish",
  "moliya.enterFull": "To'lov kiritish",
  "moliya.restNote": "Qoldiq",
  "moliya.paidMark": "To'landi",
  "moliya.paidBadge": "To'langan",
  "moliya.opsNote": "Turoperatorga to'lov mijoz pulidan oldin ketsa, kassada manfiy qoldiq hosil bo'ladi. Ustun «Mijozdan» shuni ko'rsatadi.",
  "moliya.empty.in": "To'lovlar yo'q",
  "moliya.empty.debt": "Mijozlarda qarz yo'q",
  "moliya.empty.ops": "Turoperatorlarga to'lanadigan bron yo'q",
  "moliya.empty.kas": "Kassalar yo'q",
  "moliya.branchAll": "Hammasi",
  "moliya.kas.today": "bugun",
  "moliya.kas.yesterday": "kecha",
  "moliya.kas.overdrawn": "Turoperatorga oldindan to'langan",
  "moliya.kas.none": "bugun 0",
  "moliya.prev": "Oldingi",
  "moliya.next": "Keyingi",
  "moliya.form.deal": "Bitim",
  "moliya.form.dealPlaceholder": "Bitimni tanlang",
  "moliya.form.hint": "Jami {total} · to'langan {paid} · qoldiq {rest}",
  "moliya.form.amount": "Summa",
  "moliya.form.amountRequired": "Summani kiriting",
  "moliya.form.overRemaining": "Qoldiqdan katta: {rest}",
  "moliya.form.currency": "Valyuta",
  "moliya.form.kassa": "Kassa",
  "moliya.form.kassaPlaceholder": "Kassani tanlang",
  "moliya.form.note": "Izoh",
  "moliya.form.notePlaceholder": "Masalan, qoldiq to'lov",
  "moliya.form.date": "Sana",
  "moliya.form.instalment": "Qaysi bo'lakka",
  "moliya.form.noInstalment": "Bo'lakka bog'lanmagan",
  "moliya.form.manualRate": "Kurs (1 $ uchun so'm)",
  "moliya.form.save": "Saqlash",
  "moliya.form.cancel": "Bekor qilish",
  "moliya.form.saved": "To'lov kiritildi · {amount}",
  "moliya.form.savedPending": "To'lov kiritildi · {amount} · tasdiq kutmoqda",
  "moliya.pay.title": "Turoperatorga to'lov",
  "moliya.pay.owed": "Qolgan: {amount}",
  "moliya.pay.noKassa": "{currency} kassasi yo'q. Sozlamalarda qo'shing.",
  "moliya.pay.done": "{provider}ga {amount} to'landi deb belgilandi",
  "moliya.error": "Xatolik yuz berdi",
} as const;
